import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createContactus } from "./ContactUsAPI";

const initialState = {
  value: 0,
  status: "idle",
  contactUs: null,
};



export const createContactUsAsync = createAsyncThunk(
  "contactus/createContactus",
  async (ContactUsData) => {
    const response = await createContactus(ContactUsData);

    return response.data;
  }
);



export const ContactUsSlice = createSlice({
  name: "contactus",
  initialState,

  reducers: {
    increment: (state) => {
      state.value += 1;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createContactUsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createContactUsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.contactUs = action.payload;
      });
  },
});



export const selectSendMail = (state) => state.contactus.contactUs; 


export default ContactUsSlice.reducer;
